import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, InputGroup } from '@storable/canaveral-components';
import { Lightbox } from '../../../../src/web/components';
import { resolveContentUrl } from '../../../assets';
import styles from './styles.scss';

const getThumbnailLink = (embed) => {
  // Only getting thumbnails for youtube because vimeo requires
  // sending a request to their API.
  const sourceRegex = /youtube/;
  // This will find the video id for youtube and vimeo videos
  // in order to get the video's thumbnail.
  const idRegex = /(video\/|embed\/)([^"?]+)/igm;

  if (sourceRegex.test(embed)) {
    const id = idRegex.exec(embed);
    return id ? `http://img.youtube.com/vi/${id[0].slice(6)}/0.jpg` : null;
  }

  return null;
};

const propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    mediumId: PropTypes.string,
    file: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
  })).isRequired,
  setImages: PropTypes.func.isRequired,
  setShowVideo: PropTypes.func.isRequired,
};

const Video = ({ images, setImages, setShowVideo }) => {
  const [embedCode, setEmbedCode] = useState('');
  const [showExample, setShowExample] = useState(false);

  const onCancel = () => {
    setEmbedCode('');
    setShowVideo(false);
  };

  const onAdd = () => {
    setImages([...images, { thumbnail: getThumbnailLink(embedCode), videoEmbedCode: embedCode }]);
    onCancel();
  };

  return (
    <>
      <div className={styles.videoContainer}>
        <div className={styles.videoHeader}>
          Video Embed URL
          <Button icon="tool-tip" label="embed example" onClick={() => setShowExample(true)} />
        </div>
        <div className={styles.videoText}>
          Paste the URL that appears within the video embed code here.
          This is the URL that appears between, but not including, the quotation marks.
        </div>
        <div className={styles.videoText}>
          Only videos from YouTube or Vimeo are available for use with this feature.
        </div>
        <InputGroup>
          <InputGroup.Text
            value={embedCode}
            onChange={e => setEmbedCode(e.target.value)}
            className={styles.videoInput}
          />
        </InputGroup>
        <div>
          <Button context="neutral" onClick={onCancel} className={styles.videoButton}>
          Cancel
          </Button>
          <Button context="success" onClick={onAdd} disabled={!embedCode.length} className={styles.videoButton}>
          Add
          </Button>
        </div>
      </div>
      {showExample && (
        <Lightbox
          items={[<img src={resolveContentUrl('/img/copy-url-image.png')} alt="example" />]}
          itemIndex={0}
          onClickClose={() => setShowExample(false)}
          onClickDot={() => {}}
          onClickNext={() => {}}
          onClickPrev={() => {}}
        />
      )}
    </>
  );
};

Video.propTypes = propTypes;

export default Video;
